import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import { useUpdatePaymentSuccess } from "./hooks/NetworkHooks";

export default function CheckoutForm({ amount }) {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const updatePaymentSuccess = useUpdatePaymentSuccess();


  const redirectSuccess = new URLSearchParams(window.location.search).get(
    'redirectSuccess'
  );

  const requestKey = new URLSearchParams(window.location.search).get(
    'requestKey'
  );

  const stepNum = new URLSearchParams(window.location.search).get(
    'stepNum'
  );


  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }
    stripe.retrievePaymentIntent(clientSecret).then(async ({ paymentIntent }) => {
      console.log(paymentIntent)
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });

  }, [stripe]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("")

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: "if_required"
    })

    setIsLoading(false);

    if (paymentIntent?.status === "succeeded") {
      await updatePaymentSuccess(requestKey, parseInt(stepNum));
      window.location = redirectSuccess;
    } else if (error?.type === "card_error" || error?.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }
  }

  const paymentElementOptions = {
    layout: "tabs"
  }

  return (
    <div className="payment-container">
      <form id="payment-form" className="payment-form" onSubmit={handleSubmit}>
        <div>Total amount: {amount}$</div>
        <PaymentElement id="payment-element" options={paymentElementOptions} />
        <button className="payment-button" disabled={isLoading || !stripe || !elements} id="submit">
          <span id="button-text">
            {isLoading ? <div className="payment-spinner" id="spinner"></div> : "Pay now"}
          </span>
        </button>
        {message && <div id="payment-message">{message}</div>}
        <div id="#powered-by"> Powered by <a href="https://stripe.com" target="_blank">stripe</a></div>
      </form>
    </div>
  );
}